export enum FacilityActionType {
  GET_FACILITIES_LIST_REQUEST = 'GET_FACILITIES_LIST_REQUEST',
  GET_FACILITIES_LIST_SUCCESS = 'GET_FACILITIES_LIST_SUCCESS',
  GET_FACILITIES_LIST_FAIL = 'GET_FACILITIES_LIST_FAIL',
  GET_ZONES_LIST_REQUEST = 'GET_ZONES_LIST_REQUEST',
  GET_ZONES_LIST_SUCCESS = 'GET_ZONES_LIST_SUCCESS',
  GET_ZONES_LIST_SUCCESS_NEW = 'GET_ZONES_LIST_SUCCESS_NEW',
  GET_ZONES_LIST_FAIL = 'GET_ZONES_LIST_FAIL',
  GET_GROUP_TYPES_LIST_REQUEST = 'GET_GROUP_TYPES_LIST_REQUEST',
  GET_GROUP_TYPES_LIST_SUCCESS = 'GET_GROUP_TYPES_LIST_SUCCESS',
  GET_GROUP_TYPES_LIST_FAIL = 'GET_GROUP_TYPES_LIST_FAIL',
  GET_GROUPS_LIST_REQUEST = 'GET_GROUPS_LIST_REQUEST',
  GET_GROUPS_LIST_SUCCESS = 'GET_GROUPS_LIST_SUCCESS',
  GET_GROUPS_LIST_FAIL = 'GET_GROUPS_LIST_FAIL',
  GET_GROUPS_TREE_LIST_REQUEST = 'GET_GROUPS_TREE_LIST_REQUEST',
  GET_GROUPS_TREE_LIST_SUCCESS = 'GET_GROUPS_TREE_LIST_SUCCESS',
  GET_GROUPS_TREE_LIST_FAIL = 'GET_GROUPS_TREE_LIST_FAIL',
  SET_CURRENT_GROUP_SUCCESS = 'SET_CURRENT_GROUP_SUCCESS',
  CREATE_GROUP_REQUEST = 'CREATE_GROUP_REQUEST',
  CREATE_GROUP_SUCCESS = 'CREATE_GROUP_SUCCESS',
  CREATE_GROUP_FAIL = 'CREATE_GROUP_FAIL',
  DELETE_GROUP_REQUEST = 'DELETE_GROUP_REQUEST',
  DELETE_GROUP_SUCCESS = 'DELETE_GROUP_SUCCESS',
  DELETE_GROUP_FAIL = 'DELETE_GROUP_FAIL',
  EDIT_GROUP_REQUEST = 'EDIT_GROUP_REQUEST',
  EDIT_GROUP_SUCCESS = 'EDIT_GROUP_SUCCESS',
  EDIT_GROUP_FAIL = 'EDIT_GROUP_FAIL',
  EDIT_ZONE_REQUEST = 'EDIT_ZONE_REQUEST',
  EDIT_ZONE_SUCCESS = 'EDIT_ZONE_SUCCESS',
  EDIT_ZONE_FAIL = 'EDIT_ZONE_FAIL',
  DELETE_ZONE_REQUEST = 'DELETE_ZONE_REQUEST',
  DELETE_ZONE_SUCCESS = 'DELETE_ZONE_SUCCESS',
  DELETE_ZONE_FAIL = 'DELETE_ZONE_FAIL',
  CREATE_ZONE_PROPERTY_REQUEST = 'CREATE_ZONE_PROPERTY_REQUEST',
  CREATE_ZONE_PROPERTY_SUCCESS = 'CREATE_ZONE_PROPERTY_SUCCESS',
  CREATE_ZONE_PROPERTY_FAIL = 'CREATE_ZONE_PROPERTY_FAIL',
  EDIT_ZONE_PROPERTY_REQUEST = 'EDIT_ZONE_PROPERTY_REQUEST',
  EDIT_ZONE_PROPERTY_SUCCESS = 'EDIT_ZONE_PROPERTY_SUCCESS',
  EDIT_ZONE_PROPERTY_FAIL = 'EDIT_ZONE_PROPERTY_FAIL',
  DELETE_ZONE_PROPERTY_REQUEST = 'DELETE_ZONE_PROPERTY_REQUEST',
  DELETE_ZONE_PROPERTY_SUCCESS = 'DELETE_ZONE_PROPERTY_SUCCESS',
  DELETE_ZONE_PROPERTY_FAIL = 'DELETE_ZONE_PROPERTY_FAIL',
  CREATE_ZONE_REQUEST = 'CREATE_ZONE_REQUEST',
  CREATE_ZONE_SUCCESS = 'CREATE_ZONE_SUCCESS',
  CREATE_ZONE_FAIL = 'CREATE_ZONE_FAIL',
  CREATE_GROUP_TYPE_REQUEST = 'CREATE_GROUP_TYPE_REQUEST',
  CREATE_GROUP_TYPE_SUCCESS = 'CREATE_GROUP_TYPE_SUCCESS',
  CREATE_GROUP_TYPE_FAIL = 'CREATE_GROUP_TYPE_FAIL',
  EDIT_GROUP_TYPE_REQUEST = 'EDIT_GROUP_TYPE_REQUEST',
  EDIT_GROUP_TYPE_SUCCESS = 'EDIT_GROUP_TYPE_SUCCESS',
  EDIT_GROUP_TYPE_FAIL = 'EDIT_GROUP_TYPE_FAIL',
  GET_LOGICAL_READERS_REQUEST = 'GET_LOGICAL_READERS_REQUEST',
  GET_LOGICAL_READERS_FAIL = 'GET_LOGICAL_READERS_FAIL',
  GET_LOGICAL_READERS_SUCCESS = 'GET_LOGICAL_READERS_SUCCESS',
  DELETE_LOGICAL_READER_REQUEST = 'DELETE_LOGICAL_READER_REQUEST',
  DELETE_LOGICAL_READER_FAIL = 'DELETE_LOGICAL_READER_FAIL',
  DELETE_LOGICAL_READER_SUCCESS = 'DELETE_LOGICAL_READER_SUCCESS',
  EDIT_LOGICAL_READER_REQUEST = 'EDIT_LOGICAL_READER_REQUEST',
  EDIT_LOGICAL_READER_SUCCESS = 'EDIT_LOGICAL_READER_SUCCESS',
  EDIT_LOGICAL_READER_FAIL = 'EDIT_LOGICAL_READER_FAIL',
  CREATE_LOGICAL_READER_REQUEST = 'CREATE_LOGICAL_READER_REQUEST',
  CREATE_LOGICAL_READER_SUCCESS = 'CREATE_LOGICAL_READER_SUCCESS',
  CREATE_LOGICAL_READER_FAIL = 'CREATE_LOGICAL_READER_FAIL',
  DELETE_GROUP_TYPE_REQUEST = 'DELETE_GROUP_TYPE_REQUEST',
  DELETE_GROUP_TYPE_SUCCESS = 'DELETE_GROUP_TYPE_SUCCESS',
  DELETE_GROUP_TYPE_FAIL = 'DELETE_GROUP_TYPE_FAIL',
  GET_POLYGON_SUCCESS = 'GET_POLYGON_SUCCESS',
  GET_POLYGON_FAIL = 'GET_POLYGON_FAIL',
  GET_POLYGON_REQUEST = 'GET_POLYGON_REQUEST',
  DELETE_POLYGON_REQUEST = 'DELETE_POLYGON_REQUEST',
  DELETE_POLYGON_SUCCESS = 'DELETE_POLYGON_SUCCESS',
  DELETE_POLYGON_FAIL = 'DELETE_POLYGON_FAIL',
  EDIT_POLYGON_REQUEST = 'EDIT_POLYGON_REQUEST',
  EDIT_POLYGON_SUCCESS = 'EDIT_POLYGON_SUCCESS',
  EDIT_POLYGON_FAIL = 'EDIT_POLYGON_FAIL',
  GET_POLYGONS_SUCCESS = 'GET_POLYGONS_SUCCESS',
  GET_POLYGONS_FAIL = 'GET_POLYGONS_FAIL',
  GET_POLYGONS_REQUEST = 'GET_POLYGONS_REQUEST',
  CREATE_POLYGON_REQUEST = 'CREATE_POLYGON_REQUEST',
  CREATE_POLYGON_FAIL = 'CREATE_POLYGON_FAIL',
  GET_MAPS_ORIGIN_REQUEST = 'GET_MAPS_ORIGIN_REQUEST',
  GET_MAPS_ORIGIN_SUCCESS = 'GET_MAPS_ORIGIN_SUCCESS',
  GET_MAPS_ORIGIN_FAIL = 'GET_MAPS_ORIGIN_FAIL',
  GET_MAPS_IMAGE_REQUEST= 'GET_MAPS_IMAGE_REQUEST',
  GET_MAPS_IMAGE_SUCCESS= 'GET_MAPS_IMAGE_SUCCESS',
  GET_MAPS_IMAGE_FAIL= 'GET_MAPS_IMAGE_FAIL',
  GET_MAPS_IMAGE_IMAGE_REQUEST= 'GET_MAPS_IMAGE_IMAGE_REQUEST',
  GET_MAPS_IMAGE_IMAGE_SUCCESS= 'GET_MAPS_IMAGE_IMAGE_SUCCESS',
  GET_MAPS_IMAGE_IMAGE_FAIL= 'GET_MAPS_IMAGE_IMAGE_FAIL',
  GET_MAPS_IMAGE_IMAGE_URL_SUCCESS= 'GET_MAPS_IMAGE_IMAGE_URL_SUCCESS',
  RESET_MAP_IMAGE_VALUES= 'RESET_MAP_IMAGE_VALUES',
  RESET_MAP_IMAGE_VALUES_FAIL= 'RESET_MAP_IMAGE_VALUES_FAIL',
  RESET_MAP_REPORT_VALUES='RESET_MAP_REPORT_VALUES'
}
